export class NotesModel {
    userId?: number;
    note!: string;
    entityID!: number;
    type!: string;
}
